module.exports = __webpack_public_path__ + "img/icon_map_53_on_010.4493c417.png";